import { DispatchListDetailsRes } from '@zonofi/zono-money-store';
import { ReactComponent as Transporter } from '@zonofi/svg-icons/transporter-name.svg';
import { ReactComponent as VehicleSteering } from '@zonofi/svg-icons/vehicle-steering.svg';
import { ReactComponent as Driver } from '@zonofi/svg-icons/driver.svg';
import { ReactComponent as Phone } from '@zonofi/svg-icons/phone-icon.svg';

interface TransporterVehicleDetailsProps {
  dispatchNoteDetails: DispatchListDetailsRes;
}

const getValue = (value: string | null | undefined) => value || 'N/A';
export const TransporterVehicleDetails = (
  props: TransporterVehicleDetailsProps
) => {
  const { dispatchNoteDetails } = props;

  return (
    <div className="dispatch-note-detail-box font-regular">
      <span className="dispatch-note-detail-box-heading font-semibold">
        Transporter & Vehicle details
      </span>
      <div className="dispatch-note-detail-box-content">
        <Transporter />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Transporter Name:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails.transporterName)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <VehicleSteering />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Vehicle Number:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails.vehicleNumber)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <Driver />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Driver name:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails.driverName)}
          </span>
        </div>
      </div>
      <div className="dispatch-note-detail-box-content">
        <Phone color="#868D9A" />
        <div className="dispatch-note-detail-box-content-text">
          <span className="dispatch-note-detail-box-content-text-label">
            Phone Number:{' '}
          </span>
          <span className="dispatch-note-detail-box-content-text-value">
            {getValue(dispatchNoteDetails.driverPhone)}
          </span>
        </div>
      </div>
    </div>
  );
};
